import Calendar from './Calendar';
export default Calendar;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-calendar/src/index.js